import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import classes from './StrengthPackSizeNdcManagementModal.module.scss';
import { useStrengthPackSIzeNdcManagementModal } from './useStrengthPackSizeNdcManagementModal';
import DraggableIcon from 'assets/icons/draggableIcon.svg';

const StrengthPackSizeNdcManagementModal = ({
  value,
  handleValueChange,
  moleculeName: _moleculeName,
  rowIndex,
  strengthOptions,
  strengthOptionsLoading,
}: // maxValueLimit,
{
  value: { strength: string; packsize: number; ndc: string | null }[];
  handleValueChange: (
    data: { strength: string; packsize: number; ndc: string | null }[],
    rowIndex: number
  ) => void;
  moleculeName: string;
  rowIndex: number;
  strengthOptions: {
    code: string;
    name: string;
  }[];
  strengthOptionsLoading: boolean;
}) => {
  const { inputOperations, handleDragEnd } =
    useStrengthPackSIzeNdcManagementModal(
      value,
      handleValueChange,
      rowIndex
    );

  const valueTemplate = (
    option: {
      code: string;
      name: string;
    } | null,
    value: string | null
  ) => {
    return (
      <>
        {option ? (
          <div>{option.name}</div>
        ) : (
          <>{value ? <div style={{ color: 'red' }}>{value}</div> : <div>Select...</div>}</>
        )}
      </>
    );
  };

  return (
    <div className={classes.manageStrengthsNDCPackSizeModal}>
      <DragDropContext onDragEnd={handleDragEnd}>
        <table>
          <thead>
            <th></th>
            <th>Strength</th>
            <th>PackSize</th>
            <th>NDC</th>
          </thead>
          <Droppable droppableId="strengthPackSizeTable">
            {provided => (
              <tbody {...provided.droppableProps} ref={provided.innerRef}>
                {value.map((data, index) => {
                  return (
                    <Draggable key={`row-${index}`} draggableId={`row-${index}`} index={index}>
                      {(provided, snapshot) => (
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          className="strengthPackSizeManagementTable"
                          style={{
                            ...provided.draggableProps.style,
                            backgroundColor: snapshot.isDragging ? '#f0f0f0' : 'transparent',
                          }}
                        >
                          <td>
                            <div
                              {...provided.dragHandleProps}
                              style={{
                                cursor: 'grab',
                                padding: '5px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <img src={DraggableIcon} alt="draggable" style={{ height: '20px' }} />
                            </div>
                          </td>
                          <td>
                            <Dropdown
                              valueTemplate={option =>
                                valueTemplate(option, inputOperations.strength.value(index).code)
                              }
                              value={inputOperations.strength.value(index)}
                              onChange={e => {
                                inputOperations.strength.onChange(index, e.target.value.code);
                              }}
                              options={strengthOptions}
                              optionLabel="name"
                              placeholder="Select strength"
                              loading={strengthOptionsLoading}
                              className={classes.dropDownBox}
                            />
                          </td>
                          <td>
                            <InputText
                              value={inputOperations.packSize.value(index).toString()}
                              onChange={e => {
                                inputOperations.packSize.onChange(index, e.target.value);
                              }}
                              placeholder="enter packsize"
                              style={{
                                padding: '0.3rem 0.5rem',
                                width: '100%',
                              }}
                            />
                          </td>
                          <td>
                            <InputText
                              value={inputOperations.ndc.value(index)?.toString()}
                              onChange={e => {
                                inputOperations.ndc.onChange(index, e.target.value);
                              }}
                              placeholder="enter ndc"
                              style={{
                                padding: '0.3rem 0.5rem',
                                width: '100%',
                              }}
                            />
                          </td>
                        </tr>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </tbody>
            )}
          </Droppable>
        </table>
      </DragDropContext>
    </div>
  );
};

export default StrengthPackSizeNdcManagementModal;
